// https://vuex.vuejs.org/en/state.html

export default {
    token: localStorage.getItem("user-token") || "",
    status: "",
}
